import React from "react";
import { GenericButton } from "../../components/common/GenericButton";
import { toast } from "react-toastify";
import { register } from "../../services/dashApiService";

export const Summary = ({ onDataComplete, data }) => {
	const handleRegister = () => {
		const options = {
			hideProgressBar: true,
			type: "error",
		};

		register(data)
			.then((result) => {
				if (result.success) {
					const text = (
						<>
							<p className="mb-2">You have been registered successfully.</p>
						</>
					);

					options.type = "success";
					toast(text, options);

					onDataComplete();
				} else {
					const text = (
						<>
							<p className="mb-2">We could not register you at this time.</p>
							{result.data.message.map((m) => {
								return <p className="mb-2">{m}</p>;
							})}
						</>
					);

					options.autoClose = false;
					toast(text, options);
				}
			})
			.catch(() => {
				const text = (
					<>
						<p className="mb-2">
							Sorry, we were unable to register you just at this moment.
						</p>
						<p className="mb-2">
							This is most likely because of an internet connection issue.
						</p>
						<p className="mb-2">
							Please check your connection and try again in a few seconds.
						</p>
					</>
				);

				options.autoClose = false;
				toast(text, options);
			});
	};

	return (
		<div className={"text-sm lg:text-base bg-white"}>
			{/* Header */}
			<h2 className={`text-2xl font-bold col-span-2 mb-2 text-center pt-2`}>
				Summary
			</h2>

			{/* Page Content */}
			<div className={"flex-grow pt-2 sm:pt-8 text-black"}>
				<div className={"mb-4"}>
					<p className={"mb-8"}>
						This is a summary of the information you have provided. If you want
						to change anything, please use the Back button to find what you want
						to change and press Save on the page.
					</p>
					<p className={"mb-4"}>Otherwise, please press Register.</p>
					<div className={"flex-grow justify-items-center"}>
						<dl className={"grid grid-cols-5 gap-2 text-sm break-words"}>
							<dt className={"text-right font-bold col-span-2"}>
								First name(s):
							</dt>
							<dd className={"col-span-3"}>{data.pid?.firstName}</dd>
							<dt className={"text-right font-bold col-span-2"}>Surname:</dt>
							<dd className={"col-span-3"}>{data.pid?.surname}</dd>
							<dt className={"text-right font-bold col-span-2"}>Email:</dt>
							<dd className={"col-span-3"}>{data.initialData?.email}</dd>
							<dt className={"text-right font-bold col-span-2"}>Mobile no.:</dt>
							<dd className={"col-span-3"}>{data.pid?.mobilePhone}</dd>
							<dt className={"text-right font-bold col-span-2"}>Sex:</dt>
							<dd className={"col-span-3"}>{data.pid?.sex}</dd>
							<dt className={"text-right font-bold col-span-2"}>
								Date of birth:
							</dt>
							<dd className={"col-span-3"}>{data.pid?.dobStr}</dd>
							<dt className={"text-right font-bold col-span-2"}>NHS/CHI No:</dt>
							<dd className={"col-span-3"}>{data.initialData?.nhsno}</dd>
							<dt className={"text-right font-bold col-span-2"}>Password:</dt>
							<dd className={"col-span-3"}>{data.password?.password}</dd>
							<dt className={"text-right font-bold col-span-2"}>
								Cancer type:
							</dt>
							<dd className={"col-span-3"}>{data.pid?.diseaseGroup?.label}</dd>
						</dl>
					</div>
				</div>

				<div className={"flex justify-center max-w-xs mx-auto pt-2"}>
					<div className={"w-1/2"}>
						<GenericButton
							text="Register"
							onClick={handleRegister}
							classes="active-button"
						/>
					</div>
				</div>
			</div>
		</div>
	);
};
